import React, { useContext, useEffect, useState } from 'react';
import Sidebar from './../Sidebar';
import Footer from './../Footer';
import { AuthContext } from './../AuthContext';
import { site_url_img, site_url, invoice_img } from "./../config.js";
import Pie from './../Pie';
import Monthlist from './../Transaction/Monthlist';
import CommissionHistory from './../Transaction/CommissionHistory';
import { Link } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { isStaffUser } from './../role.js';

function Index() {
  const { user, refreshUser, vendordetails, fulluser } = useContext(AuthContext);
  const [selecttab, settab] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const staffLogin = isStaffUser(fulluser);

  useEffect(() => {
    // Remove modal backdrops
    const backdrops = document.querySelectorAll(".modal-backdrop");
    backdrops.forEach((el) => el.remove());

    // Remove modal-open class
    document.body.classList.remove("modal-open");

    // Remove inline styles like overflow and padding
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";

    // Optionally, clear all inline styles (use with caution)
    // document.body.removeAttribute("style");
  }, [location]);

  useEffect(() => {
    // Check if user is authenticated
    if (!user) {
      setError('Please login to access transactions');
      setLoading(false);
      return;
    }
    
    try {
      setLoading(false);
    } catch (err) {
      setError('Failed to load transactions');
      setLoading(false);
    }
  }, [user]);

  if (loading) {
    return (
      <div id="appCapsule" className="d-flex justify-content-center align-items-center" style={{height: '100vh'}}>
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div id="appCapsule" className="d-flex justify-content-center align-items-center" style={{height: '100vh'}}>
        <div className="text-center">
          <h3 className="text-danger">Error</h3>
          <p>{error}</p>
          <button className="btn btn-primary" onClick={() => window.location.href = '/login'}>
            Go to Login
          </button>
        </div>
      </div>
    );
  }

  // Additional safety check - don't render if user data is not available
  if (!user && !fulluser) {
    return (
      <div id="appCapsule" className="d-flex justify-content-center align-items-center" style={{height: '100vh'}}>
        <div className="text-center">
          <h3 className="text-warning">Loading User Data</h3>
          <p>Please wait while we load your information...</p>
        </div>
      </div>
    );
  }

  return (
    <div id="appCapsule">

      <Footer />
      <Sidebar />
      <div>
        <div class="card">
          <div class="card-body">

            <ul class="nav nav-tabs lined" role="tablist">
              <li class="nav-item">
                <a onClick={() => settab(1)} class={`nav-link ${selecttab === 1 ? 'active' : ''}`} data-bs-toggle="tab" href="#example1b" role="tab" aria-selected="true">
                  <ion-icon name="receipt" role="img" class="md hydrated" aria-label="receipt"></ion-icon>
                  Transactions
                </a>
              </li>
              {!staffLogin && (
              <li class="nav-item">
                <a onClick={() => settab(2)} class={`nav-link ${selecttab === 2 ? 'active' : ''}`} data-bs-toggle="tab" href="#example2b" role="tab" aria-selected="false">
                  <ion-icon name="cash-outline" role="img" class="md hydrated" aria-label="cash outline"></ion-icon>
                  Commission History
                </a>
              </li>
              )}
            </ul>

          </div>
        </div>
      </div>
      {selecttab == 1 ? (
        <div>
      <Pie />
      <div>
        <div className="section mt-4">
          <div className="section-heading">
            <h2 className="title">Transactions</h2>


          </div>
          <div className="transactions">
            <Monthlist />
          </div>
        </div>
      </div>
      </div>
      ) : selecttab == 2 ? (
        <div>
      <div>
        <div className="section mt-4">
          <div className="section-heading">
            <h2 className="title">Commission Payment History</h2>
          </div>
          <div className="transactions">
            <CommissionHistory />
          </div>
        </div>
      </div>
      </div>
      ) : null}


    </div>
  )
}

export default Index